import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import { ColorPicker } from "material-ui-color";
import { Radio, TextField } from "@mui/material";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";

const axisType = { 0: "Линия", 1: "Область" };

class ReportChartAxisConstructorToolpanel extends Component {
  constructor(props) {
    super(props);

    if (props.field !== null) {
      this.state = {
        color: props.field.chartAxis.color,
        useSecondaryAxis: props.field.chartAxis.useSecondaryAxis,
        type: props.field.chartAxis.type,
        valueOn: props.field.chartAxis.valueOn,
        isChange: false,
      };
    }
  }

  componentDidUpdate(preProps) {
    const { updateCustomReportAxisDataState } = this.props;

    if (updateCustomReportAxisDataState === states.REQUEST && preProps.updateCustomReportAxisDataState !== states.REQUEST) {
      this.setState({ isChange: false });
    }
  }

  onHandleSave() {
    const { onUpdateCustomReportAxis, field, selectedCustomReportId } = this.props;
    const { color, useSecondaryAxis, type, isChange, valueOn } = this.state;

    onUpdateCustomReportAxis(
      {
        id: field.chartAxis.id,
        color,
        useSecondaryAxis,
        type,
        valueOn: valueOn,
      },
      selectedCustomReportId
    );
  }

  render() {
    const { field } = this.props;

    if (field === null) {
      return null;
    }

    const { color, useSecondaryAxis, type, isChange, valueOn } = this.state;
    const isBoolValue = field.dashboard.type === 13;

    return (
      <div className={styles.axisToolPanelContainer}>
        <h2>{field.dashboard.title}</h2>
        <div>
          <div className={styles.axisToolPanelTool}>
            <p>Цвет</p>
            <ColorPicker
              value={color}
              onChange={(e) => {
                this.setState({ color: "#" + e.hex, isChange: true });
              }}
            />
          </div>

          <div className={styles.axisToolPanelTool}>
            <p>Ось данных</p>
            <div className={styles.radioButtomContainer}>
              <div
                onClick={() => {
                  this.setState({ useSecondaryAxis: false, isChange: true });
                }}
              >
                <Radio checked={!useSecondaryAxis} size="small" /> Левая
              </div>
              <div
                onClick={() => {
                  this.setState({ useSecondaryAxis: true, isChange: true });
                }}
              >
                <Radio checked={useSecondaryAxis} size="small" /> Правая
              </div>
            </div>
          </div>

          {!isBoolValue ? (
            <div className={styles.axisToolPanelTool}>
              <p>Тип</p>
              <div className={styles.radioButtomContainer}>
                <div
                  onClick={() => {
                    this.setState({ type: 0, isChange: true });
                  }}
                >
                  <Radio checked={type === 0} size="small" /> Линия
                </div>
                <div
                  onClick={() => {
                    this.setState({ type: 1, isChange: true });
                  }}
                >
                  <Radio checked={type === 1} size="small" /> Область
                </div>
              </div>
            </div>
          ) : null}

          {isBoolValue ? (
            <div className={styles.axisToolPanelTool}>
              <p>Высота области положительного значения </p>
              <TextField
                value={valueOn}
                id="outlined-basic"
                variant="outlined"
                size="small"
                type="number"
                InputProps={{ inputProps: { min: 1 } }}
                onChange={(e) => {
                  if (parseInt(e.target.value) >= 1) {
                    this.setState({ valueOn: e.target.value, isChange: true });
                  }
                }}
              />
            </div>
          ) : null}

          {isChange ? (
            <div className={styles.axisToolPanelTool}>
              <ButtonPrimary handleClick={this.onHandleSave.bind(this)} title="Сохранить" />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportChartAxisConstructorToolpanel)));
